import axios from "axios";
import { is } from "date-fns/locale";
import React, { useEffect, useState } from "react";
import createFilterOptions from "react-select-fast-filter-options";
import { useHistory, useLocation } from "react-router-dom";
import Select,{ createFilter }  from "react-select";
import { DateFormatter } from "../Utils/DateFormatter";
import CustomOption from "../Utils/CustomOption";
import CustomMenuList from "../Utils/CustomMenuList";
import {getTerminalContactDetailsByIDApi} from "../Api";

const columns = [
  "Make & Model",
  "Serial Number",
  "Installation Date",
  "Activation Date",
  "Installing User",
  "Iso Name",
  "Owner",
  "Status",
  "Last Transaction",
  "Last Management",
  "Total Cassette",
  "Last Settled Time",
  "Withdrawl ct",
  "Dispensed Amt",
  " Model Features List",
  "Location Name",
  "Location Type",
  "Address",
  "city",
  "state",
  "zip Code",
  "Time zone",
  "GateWay",
];

function TerminalDetail(props) {
  //console.log(props, "2121");
  const location = useLocation();
  const [data, setData] = useState();
    const [contactData, setContactData] = useState();
  const [isEditable, setIsEditable] = useState(false);
  const [terminalSelectData, setTerminalSelectData] = useState([]);
  const [selectedTerminal, setSelectedTerminal] = useState();
    const [activeIconStatus, setActiveIconStatus] = useState();
    const [cashIconStatus, setCashIconStatus] = useState();
  const history = useHistory();
    const filterOptions = createFilterOptions({
        terminalSelectData
    });
  useEffect(() => {
    const fetchData = async () => {
      let result = await axios.get(
        `getTerminalDetailsByID?termId=${location.search?.split("=")?.[1]}&searchCriteria=""&lastTxn=10`);

        let contactResultSet = await axios.get(
            `${getTerminalContactDetailsByIDApi}?paramSourceCode=${location.search?.split("=")?.[1]}&paramSourceType=2`);
      setData(result.data.response[0]);
        setContactData(contactResultSet.data.response[0]);
      setActiveIconStatus(result.data?.response[0].generalStatus.includes("Not Live")?"/assets/images/icons/shield-black.png":"/assets/images/icons/shield-grey.png")
        setCashIconStatus(result.data?.response[0].cashStatus.includes("GOOD")?"/assets/images/icons/shield-green.png":"/assets/images/icons/shield-red.png")

    };
    fetchData();
  }, [location.search]);
  useEffect(() => {
    const terminalId = location?.search?.split("=")?.[1];
    setSelectedTerminal();

    console.log("result props ",props)
    props?.terminalsData?.map((item, index) =>
      setTerminalSelectData((options) => [
        ...options,
        { value: item?.terminalID, label: item?.terminalID },
      ])
    );
    setSelectedTerminal({ label: terminalId, value: terminalId });
    return () => {
      setTerminalSelectData([]);
    };
  }, [props, location]);
  const handleTerminalSelectClick = () => {
    history.push({
      pathname: "/termManagement/terMinalDetails",
      search: `terminalID=${selectedTerminal.value}`,
    });
  };
  return (
    <div className="mt-3">
      <div className="d-flex flex-row align-items-center justify-content-between">
        <form>
          <div class="form-group form-inline">
            <label for="exampleInputEmail1">Terminal ID:</label>
            <div class="input-group ml-2">
              <Select
                options={terminalSelectData}
                filterOption={createFilter({ ignoreAccents: false })}
                captureMenuScroll={false}
                classNamePrefix="custom-select"
                components={{ Option: CustomOption, MenuList: CustomMenuList }}
                value={selectedTerminal}
                onChange={(e) => setSelectedTerminal(e)}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    flex: 1,
                    width: "13vw",
                  }),
                }}
              />
              <span
                class="input-group-text"
                role="button"
                onClick={handleTerminalSelectClick}
              >
                Go
              </span>
            </div>
          </div>
        </form>
        <div className="d-flex flex-column">
          <div>
            <h6 style={{ display: "inline-block" }}>Activated- Not Live</h6>
            <img
              src={activeIconStatus}
              height={15}
              width={15}
              className="ml-1"
            />
          </div>
          <div>
            <h6 style={{ display: "inline-block" }}>Low or Out of Cash</h6>
            <img
              src={cashIconStatus}
              height={15}
              width={15}
              className="ml-1"
            />
          </div>
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-xl-5">
          {columns.map((col) => (
            <h6 style={{ fontWeight: "bold" }}>{`${col}:`}</h6>
          ))}
        </div>
        <div className="col-xl-7">
          <h6>{data?.make +" "+ data?.model}</h6>
          <h6>{data?.serialNum}</h6>
          <h6>{DateFormatter(data?.installDate)}</h6>
          <h6>{DateFormatter(data?.activationDate)}</h6>
          <h6>{data?.installUserID}</h6>
          <h6>{data?.isoname || "-"}</h6>
          <h6>{data?.ownerUserID}</h6>
          <h6>{data?.activationDate ? "Active" : "Not Active"}</h6>
          <h6>{DateFormatter(data?.lastTransTime)}</h6>
          <h6>{DateFormatter(data?.lastMgmtTime)}</h6>
          <h6>{data?.totalCassetteCount || 0}</h6>
          <h6>{DateFormatter(data?.settLastSettledTime)}</h6>
          <h6>{DateFormatter(data?.settLastSettledTime)}</h6>
          <h6>{`$ ${data?.settDispAmt || 0.0}`}</h6>
          <h6>{data?.settDispAmt}</h6>
          <h6>{data?.features}</h6>
          <h6>{data?.locationName}</h6>
          <h6>{data?.locationType}</h6>
          <h6>{data?.address}</h6>
          <h6>{data?.city}</h6>
          <h6>{data?.regionName}</h6>
          <h6>{data?.postalCode}</h6>
          <h6>{data?.timeZoneName}</h6>
          <div>
            <div className="d-flex flex-row align-items-center justify-content-between">
              <form>
                <div class="form-group form-inline">
                    <select>
                        <option>Default Gateway</option>
                    </select>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* table */}
        <div style={{ marginLeft: "1%", width: "100%" }}>
          <h6
            style={{
              fontWeight: "bold",
              textDecoration: "underline",
              marginBottom: "2%",
            }}
          >
            Contacts:
          </h6>
          <div className="table-responsive">
            <table className="table table-bordered small">
              <thead className="thead-light">
                <th>contactName</th>
                <th>Phone</th>
                <th>Fax</th>
                <th>Email</th>
              </thead>
              <tbody>
                <tr>
                  <td>{contactData?.contactName}</td>
                  <td>{contactData?.phone}</td>
                  <td>{contactData?.fax}</td>
                  <td>{contactData?.email}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TerminalDetail;
